import { FoldersViewList } from "../../../DataDrive"
import { Helmet } from "react-helmet-async"

export default function DataDrivePage() {
	return (
		<>
			<Helmet>
				<title>Data Drive</title>
			</Helmet>
			<FoldersViewList />
		</>
	)
}
